import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RsbService } from '../../../service/rsb.service';

@Component({
  selector: 'app-declaration-publish',
  templateUrl: './declaration-publish.component.html',
  styleUrls: ['./declaration-publish.component.css']
})
export class DeclarationPublishComponent implements OnInit {

  declarationForm!: FormGroup;

  errorMessage = '';
  successMessage = '';

  otpSent = false;
  otpVerified = false;

  sendOtpLoading = false;
  verifyOtpLoading = false;

  mobileNumber = '';
  maskedPhone = '******3210';

 otpCode = '';
 showVerificationSection = true;

// Free Listing


selectedListingOption = '';

isFreeSelected = false;
  isPremiumSelected = false;

  isNexusSelected = false;
  nexus = '';
  listingType = '';

  commissionPercentage: number | null = null;

  optionsDisabled = false;

  constructor(
    private fb: FormBuilder,
    private rsbService: RsbService
  ) {}

 ngOnInit(): void {

  this.declarationForm = this.fb.group({});

  // Default selection
  this.selectedListingOption = 'free';
  this.isFreeSelected = true;
  this.isPremiumSelected = false;


  // Example
  this.mobileNumber = '9876543210';
}
  onListingOptionChange(type: string): void {

    this.otpSent = false;
this.otpCode = '';

    this.selectedListingOption = type;

    this.isFreeSelected = type === 'free';
    this.isPremiumSelected = type === 'premium';

    if (!this.isPremiumSelected) {
      this.isNexusSelected = false;
      this.nexus = '';
      this.commissionPercentage = null;
    }
  }

  onNexusChange(event: any): void {

    this.otpSent = false;
this.otpCode = '';
    this.isNexusSelected = event.target.checked;

    if (!this.isNexusSelected) {
      this.nexus = '';
    }
  }

  onNexusConsentChange(value: string): void {

    this.otpSent = false;
this.otpCode = '';
    this.nexus = value;
  }

  onCommissionChange(value: any): void {

    if (value === '') {
      this.commissionPercentage = null;
      return;
    }

    this.commissionPercentage = Number(value);
  }

  get showOtpSection(): boolean {

  // FREE
  if (this.isFreeSelected) {
    return true;
  }

  // PREMIUM (WITHOUT NEXUS)
  if (
    this.isPremiumSelected &&
    !this.isNexusSelected &&
    this.commissionPercentage &&
    this.commissionPercentage > 0
  ) {
    return true;
  }

  // PREMIUM + NEXUS
  if (
    this.isPremiumSelected &&
    this.isNexusSelected &&
    (this.nexus === 'yes' ||
     this.nexus === 'no')
  ) {
    return true;
  }

  return false;
}

  get sendOtpEnabled(): boolean {

    // FREE
    if (this.isFreeSelected) {
      return true;
    }

    // PREMIUM WITHOUT NEXUS
    if (
      this.isPremiumSelected &&
      !this.isNexusSelected &&
      this.commissionPercentage &&
      this.commissionPercentage > 0
    ) {
      return true;
    }

    // PREMIUM WITH NEXUS
    if (
      this.isPremiumSelected &&
      this.isNexusSelected &&
      this.commissionPercentage &&
      this.commissionPercentage > 0 &&
      (this.nexus === 'yes' ||
       this.nexus === 'no')
    ) {
      return true;
    }

    return false;
  }

 sendOtp(): void {

  if (!this.isValidMobile(this.mobileNumber)) {
    this.errorMessage = 'Enter valid mobile number';
    return;
  }

  this.sendOtpLoading = true;
  this.errorMessage = '';
  this.successMessage = '';

  const request$ = this.otpSent
    ? this.rsbService.resendBuilderDeclarationMobileOtp(this.mobileNumber, '91')
    : this.rsbService.sendBuilderDeclarationMobileOtp(this.mobileNumber, '91');

  request$.subscribe(
    (response) => {
      this.sendOtpLoading = false;

      if (response?.statusCode === 0) {
        this.otpSent = true;
        this.optionsDisabled = true;
        this.successMessage = response?.statusMessage || 'OTP sent successfully';
      } else {
        this.otpSent = false;
        this.errorMessage = response?.statusMessage || 'Unable to send OTP';
      }
    },
    () => {
      this.sendOtpLoading = false;
      this.otpSent = false;
      this.errorMessage = 'Unable to send OTP';
    }
  );
}

  verifyOtp(): void {

  if (!this.otpCode || this.otpCode.length !== 6) {

    this.errorMessage = 'Enter valid OTP';
    return;
  }

  // Listing Type
  const listingType = this.isFreeSelected ? 'FREE' : 'PREMIUM';

  const commission = this.commissionPercentage ? this.commissionPercentage : 0;

  // Nexus Value
  // Free Listing -> null
  // Premium without Nexus -> null
  // Premium + Nexus -> yes / no
 const nexus = this.isNexusSelected ? this.nexus : '';

  console.log('listingType:', listingType);
  console.log('nexus:', nexus);

  this.verifyOtpLoading = true;
  this.errorMessage = '';
  this.successMessage = '';

  this.rsbService.verifyBuilderDeclarationMobileOtp(
    this.mobileNumber,
    this.otpCode,
    '91',
    listingType,
    nexus,
    commission
  ).subscribe(

    (response) => {

      this.verifyOtpLoading = false;

      if (response?.statusCode === 0) {

        this.otpVerified = true;
        this.optionsDisabled = false;

        this.successMessage =
          response?.statusMessage || 'OTP verified successfully';

      } else {

        this.otpVerified = false;

        this.errorMessage =
          response?.statusMessage || 'OTP verification failed';
      }

    },

    () => {

      this.verifyOtpLoading = false;
      this.otpVerified = false;

      this.errorMessage =
        'OTP verification failed';

    }

  );

}

  publish(): void {

    const payload = {

      listingType: this.isFreeSelected
        ? 'FREE'
        : 'PREMIUM',

      commissionPercentage:
        this.commissionPercentage,

      nexusEnabled:
        this.isNexusSelected,

      nexusConsent:
        this.nexus
    };

    console.log(payload);

    this.successMessage =
      'Property published successfully';
  }

  goBack(): void {
    window.history.back();
  }

  isValidMobile(mobile: string): boolean {
  return /^[0-9]{10}$/.test(mobile);
}

isValidOtp(otp: string): boolean {
  return /^[0-9]{6}$/.test(otp);
}

  onlyNumbers(event: KeyboardEvent): boolean {

    const charCode =
      event.which ? event.which : event.keyCode;

    if (charCode < 48 || charCode > 57) {

      event.preventDefault();
      return false;
    }

    return true;
  }
}